(function () {
  var mapInstance = null;
  var markers = [];
  var mapInitialized = false;
  var mapsScriptRequested = false;
  var pendingFocusItem = null;
  var geocodeBusy = false;
  var geocodeQueueTimer = null;
  var userMapViewLocked = false;
  var infoWindow = null;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var PIN_ICON =
    '<svg class="organyco-icon customers-map-info__pin" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>' +
    '<circle cx="12" cy="10" r="3"></circle></svg>';

  var STAR_ICON =
    '<svg class="organyco-icon customers-map-info__star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>';

  var EXTERNAL_ICON =
    '<svg class="organyco-icon customers-map-info__cta-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M15 3h6v6"></path><path d="M10 14 21 3"></path><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path></svg>';

  function getOrCreateInfoWindow() {
    if (!infoWindow && window.google && window.google.maps) {
      infoWindow = new google.maps.InfoWindow({
        maxWidth: 288,
        pixelOffset: new google.maps.Size(0, -4)
      });
    }
    return infoWindow;
  }

  function buildMarkerInfoContent(item) {
    if (!item) return '';

    var name = item.dataset.displayName || '';
    var city = item.dataset.displayCity || '';
    var province = item.dataset.displayProvince || '';
    var url = item.dataset.url || '';
    var category = (item.dataset.category || '').toLowerCase();
    var image = item.dataset.image || '';
    var isPremium = category === 'premium';

    var locationLine = city;
    if (province && province.toLowerCase() !== city.toLowerCase()) {
      locationLine = locationLine ? locationLine + ', ' + province : province;
    }

    var imageHtml = image
      ? '<div class="customers-map-info__media"><img src="' +
        escapeHtml(image) +
        '" alt="" width="288" height="144" loading="lazy" decoding="async"></div>'
      : '';

    var badgeHtml = isPremium
      ? '<span class="customers-map-info__badge">Premium</span>'
      : '';

    var linkHtml = url
      ? '<a class="customers-map-info__cta" href="' +
        escapeHtml(url) +
        '" target="_blank" rel="noopener noreferrer">' +
        EXTERNAL_ICON +
        '<span>Ver sitio</span></a>'
      : '';

    var premiumClass = isPremium ? ' customers-map-info--premium' : '';

    return (
      '<div class="customers-map-info' +
      premiumClass +
      '">' +
      imageHtml +
      '<div class="customers-map-info__body">' +
      '<div class="customers-map-info__row">' +
      '<div class="customers-map-info__main">' +
      '<div class="customers-map-info__title-row">' +
      (isPremium ? STAR_ICON : '') +
      '<h3 class="customers-map-info__name">' +
      escapeHtml(name) +
      '</h3>' +
      '</div>' +
      (locationLine
        ? '<p class="customers-map-info__location">' +
          PIN_ICON +
          '<span>' +
          escapeHtml(locationLine) +
          '</span></p>'
        : '') +
      '</div>' +
      badgeHtml +
      '</div>' +
      linkHtml +
      '</div></div>'
    );
  }

  function styleInfoWindowChrome() {
    var iw = document.querySelector('.customers-directory .gm-style-iw-c');
    if (iw && !iw.classList.contains('customers-map-info-window')) {
      iw.classList.add('customers-map-info-window');
    }
  }

  function clearInfoWindowCloseFocus() {
    var closeBtn = document.querySelector('.customers-directory .gm-style-iw-chr button');
    if (closeBtn && typeof closeBtn.blur === 'function') {
      closeBtn.blur();
    }
    if (
      document.activeElement &&
      document.activeElement.closest &&
      document.activeElement.closest('.gm-style-iw-chr') &&
      typeof document.activeElement.blur === 'function'
    ) {
      document.activeElement.blur();
    }
  }

  function scheduleInfoWindowChromeFix() {
    styleInfoWindowChrome();
    clearInfoWindowCloseFocus();
    window.requestAnimationFrame(clearInfoWindowCloseFocus);
    window.setTimeout(clearInfoWindowCloseFocus, 0);
    window.setTimeout(clearInfoWindowCloseFocus, 50);
  }

  function openInfoWindowForItem(item) {
    if (!mapInstance || !item) return;
    var entry = findMarkerEntry(item);
    if (!entry) return;
    var iw = getOrCreateInfoWindow();
    if (!iw) return;
    iw.setContent(buildMarkerInfoContent(item));
    google.maps.event.addListenerOnce(iw, 'domready', scheduleInfoWindowChromeFix);
    iw.open({ map: mapInstance, anchor: entry.marker });
  }

  function closeInfoWindow() {
    if (infoWindow) infoWindow.close();
  }

  function getCustomerItems(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.customers-item'));
  }

  function getVisibleCustomerItems(root) {
    return getCustomerItems(root).filter(function (item) {
      return !item.classList.contains('hidden');
    });
  }

  function getMobilePageSize(root) {
    var size = parseInt(root.dataset.mobilePageSize || '5', 10);
    if (Number.isNaN(size) || size < 1) return 5;
    return size;
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function applyMobileListPagination(root, resetLimit) {
    var loadMoreBtn = root.querySelector('#customers-directory-load-more');
    var pageSize = getMobilePageSize(root);

    if (!isMobileViewport()) {
      getCustomerItems(root).forEach(function (item) {
        item.classList.remove('customers-directory__item--mobile-collapsed');
      });
      if (loadMoreBtn) loadMoreBtn.hidden = true;
      root.dataset.mobileVisibleLimit = '';
      return;
    }

    var matched = getVisibleCustomerItems(root);
    var limit = resetLimit
      ? pageSize
      : parseInt(root.dataset.mobileVisibleLimit || String(pageSize), 10);
    if (Number.isNaN(limit) || limit < pageSize) limit = pageSize;

    root.dataset.mobileVisibleLimit = String(limit);

    matched.forEach(function (item, index) {
      item.classList.toggle('customers-directory__item--mobile-collapsed', index >= limit);
    });

    if (loadMoreBtn) {
      loadMoreBtn.hidden = limit >= matched.length;
    }
  }

  function ensureMobileItemVisible(root, item) {
    if (!isMobileViewport() || !item || item.classList.contains('hidden')) return;

    var matched = getVisibleCustomerItems(root);
    var index = matched.indexOf(item);
    if (index < 0) return;

    var pageSize = getMobilePageSize(root);
    var limit = parseInt(root.dataset.mobileVisibleLimit || String(pageSize), 10);
    var needed = index + 1;
    if (needed <= limit) return;

    root.dataset.mobileVisibleLimit = String(
      Math.ceil(needed / pageSize) * pageSize
    );
    applyMobileListPagination(root, false);
  }

  function getListedVisibleCount(root) {
    return getVisibleCustomerItems(root).filter(function (item) {
      return !item.classList.contains('customers-directory__item--mobile-collapsed');
    }).length;
  }

  function findItemByCustomerHandle(root, handle) {
    if (!root || handle == null || handle === '') return null;
    var h = String(handle);
    var nodes = root.querySelectorAll('.customers-item[data-customer-handle]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-customer-handle') === h) return nodes[i];
    }
    return null;
  }

  var PIN_DEFAULT_URL = 'https://maps.gstatic.com/mapfiles/ms2/micons/red.png';
  var PIN_SELECTED_URL = 'https://maps.gstatic.com/mapfiles/ms2/micons/green.png';

  function markerIconDefault() {
    return {
      url: PIN_DEFAULT_URL,
      scaledSize: new google.maps.Size(32, 32),
      anchor: new google.maps.Point(16, 32)
    };
  }

  function markerIconSelected() {
    return {
      url: PIN_SELECTED_URL,
      scaledSize: new google.maps.Size(40, 40),
      anchor: new google.maps.Point(20, 40)
    };
  }

  function updateCount(root, visibleFiltered, total) {
    var visibleNode = root.querySelector('#customers-visible-count');
    var totalNode = root.querySelector('#customers-total-count');
    var displayed = isMobileViewport() ? getListedVisibleCount(root) : visibleFiltered;
    if (visibleNode) visibleNode.textContent = String(displayed);
    if (totalNode) totalNode.textContent = String(visibleFiltered);
  }

  function filterItems(root) {
    var searchInput = root.querySelector('#customers-search');
    var provinceFilter = root.querySelector('#customers-province-filter');
    var query = (searchInput && searchInput.value ? searchInput.value : '').toLowerCase().trim();
    var province = (provinceFilter && provinceFilter.value ? provinceFilter.value : '').toLowerCase().trim();
    var items = getCustomerItems(root);
    var visible = 0;

    items.forEach(function (item) {
      var name = item.dataset.name || '';
      var city = item.dataset.city || '';
      var itemProvince = item.dataset.province || '';
      var address = item.dataset.address || '';
      var matchesQuery = !query || name.indexOf(query) > -1 || city.indexOf(query) > -1 || address.indexOf(query) > -1;
      var matchesProvince = !province || itemProvince === province;
      var matches = matchesQuery && matchesProvince;
      item.classList.toggle('hidden', !matches);
      if (matches) visible += 1;
    });

    updateCount(root, visible, items.length);
    applyMobileListPagination(root, true);
    if (mapInitialized) {
      var selected = getSelectedItem(root);
      if (selected && selected.classList.contains('hidden')) {
        userMapViewLocked = false;
        closeInfoWindow();
        setSelectedItem(root, null);
        selected = null;
      }
      renderMarkers(root, { fitBounds: !selected && !userMapViewLocked });
      scheduleGeocodeDrain(root);
    }
  }

  function populateProvinceOptions(root) {
    var select = root.querySelector('#customers-province-filter');
    if (!select) return;

    var provinces = {};
    getCustomerItems(root).forEach(function (item) {
      var province = (item.dataset.province || '').trim();
      if (province) provinces[province] = true;
    });

    Object.keys(provinces)
      .sort(function (a, b) {
        return a.localeCompare(b);
      })
      .forEach(function (province) {
        var option = document.createElement('option');
        option.value = province;
        option.textContent = province.toUpperCase();
        select.appendChild(option);
      });
  }

  function createMarkerForItem(root, item, position, isSelected) {
    var marker = new google.maps.Marker({
      position: position,
      map: mapInstance,
      icon: isSelected ? markerIconSelected() : markerIconDefault(),
      zIndex: isSelected ? 1000 : 1,
      optimized: true
    });
    marker.addListener('click', function () {
      focusItemOnMap(root, item);
    });
    return marker;
  }

  function getSelectedItem(root) {
    return root.querySelector('.customers-item.is-selected');
  }

  function findMarkerEntry(item) {
    for (var i = 0; i < markers.length; i++) {
      if (markers[i].item === item) return markers[i];
    }
    return null;
  }

  function syncMarkerIconsWithSelection(root) {
    if (!mapInstance || !markers.length) return;
    var selected = getSelectedItem(root);
    markers.forEach(function (entry) {
      var isSel = selected && entry.item === selected;
      entry.marker.setIcon(isSel ? markerIconSelected() : markerIconDefault());
      entry.marker.setZIndex(isSel ? 1000 : 1);
    });
  }

  function fitMapToMarkers() {
    if (!mapInstance || !markers.length || userMapViewLocked) return;

    var bounds = new google.maps.LatLngBounds();
    markers.forEach(function (entry) {
      var pos = entry.marker.getPosition();
      if (pos) bounds.extend(pos);
    });

    if (bounds.isEmpty()) return;

    if (markers.length === 1) {
      mapInstance.setCenter(markers[0].marker.getPosition());
      mapInstance.setZoom(11);
      return;
    }

    mapInstance.fitBounds(bounds, { top: 56, right: 56, bottom: 56, left: 56 });
    var maxZ = 11;
    google.maps.event.addListenerOnce(mapInstance, 'bounds_changed', function () {
      if (mapInstance.getZoom() > maxZ) mapInstance.setZoom(maxZ);
    });
  }

  function removeMarkerEntry(entry) {
    entry.marker.setMap(null);
    markers = markers.filter(function (m) {
      return m !== entry;
    });
  }

  function upsertMarkerForItem(root, item) {
    if (!mapInstance || !window.google || !window.google.maps) return null;

    var lat = parseFloat(item.dataset.lat || '');
    var lng = parseFloat(item.dataset.lng || '');
    if (Number.isNaN(lat) || Number.isNaN(lng)) return null;

    var position = { lat: lat, lng: lng };
    var selected = getSelectedItem(root);
    var isSelected = selected === item;
    var existing = findMarkerEntry(item);

    if (existing) {
      existing.marker.setPosition(position);
      existing.marker.setMap(mapInstance);
      existing.marker.setIcon(isSelected ? markerIconSelected() : markerIconDefault());
      existing.marker.setZIndex(isSelected ? 1000 : 1);
      return existing.marker;
    }

    var marker = createMarkerForItem(root, item, position, isSelected);
    markers.push({ marker: marker, item: item });
    return marker;
  }

  function syncMarkersWithVisibleItems(root, options) {
    if (!mapInstance || !window.google || !window.google.maps) return;

    options = options || {};
    var fitBounds = options.fitBounds === true;
    var visibleItems = getVisibleCustomerItems(root);
    var visibleSet = {};
    visibleItems.forEach(function (visibleItem) {
      visibleSet[visibleItem.dataset.customerHandle || visibleItem] = true;
    });

    markers.slice().forEach(function (entry) {
      var key = entry.item.dataset.customerHandle || entry.item;
      if (!visibleSet[key]) {
        removeMarkerEntry(entry);
      }
    });

    visibleItems.forEach(function (item) {
      upsertMarkerForItem(root, item);
    });

    syncMarkerIconsWithSelection(root);

    if (fitBounds && !userMapViewLocked && !getSelectedItem(root)) {
      fitMapToMarkers();
    }
  }

  function renderMarkers(root, options) {
    syncMarkersWithVisibleItems(root, options);
  }

  function geocodeAddress(address, callback) {
    if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
      callback(null);
      return;
    }

    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, function (results, status) {
      if (status === 'OK' && results && results[0] && results[0].geometry && results[0].geometry.location) {
        callback(results[0].geometry.location);
      } else {
        callback(null);
      }
    });
  }

  function getItemGeocodeAddress(item) {
    return (item.dataset.geocodeAddress || item.dataset.address || '').trim();
  }

  function findFirstVisibleWithoutCoords(root) {
    var visible = getVisibleCustomerItems(root);
    for (var i = 0; i < visible.length; i++) {
      var item = visible[i];
      var lat = parseFloat(item.dataset.lat || '');
      var lng = parseFloat(item.dataset.lng || '');
      if (!Number.isNaN(lat) && !Number.isNaN(lng)) continue;
      var addr = getItemGeocodeAddress(item);
      if (!addr) continue;
      if (item.dataset.geocodeFailed === '1') continue;
      return item;
    }
    return null;
  }

  function scheduleGeocodeDrain(root) {
    if (geocodeQueueTimer) window.clearTimeout(geocodeQueueTimer);
    geocodeQueueTimer = window.setTimeout(function () {
      geocodeQueueTimer = null;
      geocodeDrainStep(root);
    }, 400);
  }

  function geocodeDrainStep(root) {
    if (!mapInstance || geocodeBusy) return;
    var item = findFirstVisibleWithoutCoords(root);
    if (!item) return;

    var addr = getItemGeocodeAddress(item);
    geocodeBusy = true;
    geocodeAddress(addr, function (location) {
      geocodeBusy = false;
      if (location) {
        item.dataset.lat = String(location.lat());
        item.dataset.lng = String(location.lng());
        upsertMarkerForItem(root, item);
        syncMarkerIconsWithSelection(root);
      } else {
        item.dataset.geocodeFailed = '1';
      }
      scheduleGeocodeDrain(root);
    });
  }

  function setSelectedItem(root, item) {
    getCustomerItems(root).forEach(function (customerItem) {
      customerItem.classList.toggle('is-selected', customerItem === item);
    });
  }

  function panMapToItem(item) {
    if (!mapInstance || !item) return;
    var lat = parseFloat(item.dataset.lat || '');
    var lng = parseFloat(item.dataset.lng || '');
    if (Number.isNaN(lat) || Number.isNaN(lng)) return;
    mapInstance.setCenter({ lat: lat, lng: lng });
    mapInstance.setZoom(11);
    openInfoWindowForItem(item);
  }

  function focusItemOnMap(root, item) {
    if (!item) return;
    ensureMobileItemVisible(root, item);
    setSelectedItem(root, item);
    userMapViewLocked = true;

    if (!mapInitialized || !mapInstance) {
      pendingFocusItem = item;
      loadGoogleMapsScript(root);
      return;
    }

    var lat = parseFloat(item.dataset.lat || '');
    var lng = parseFloat(item.dataset.lng || '');
    if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
      upsertMarkerForItem(root, item);
      syncMarkerIconsWithSelection(root);
      panMapToItem(item);
      return;
    }

    var address = getItemGeocodeAddress(item);
    if (!address) return;

    geocodeAddress(address, function (location) {
      if (!location) return;
      item.dataset.lat = String(location.lat());
      item.dataset.lng = String(location.lng());
      upsertMarkerForItem(root, item);
      syncMarkerIconsWithSelection(root);
      panMapToItem(item);
    });
  }

  function clearMapSelection(root) {
    userMapViewLocked = false;
    closeInfoWindow();
    setSelectedItem(root, null);
    syncMarkerIconsWithSelection(root);
    fitMapToMarkers();
    scheduleGeocodeDrain(root);
  }

  function initGoogleMap(root) {
    if (mapInitialized || !window.google || !window.google.maps) return;

    var canvas = root.querySelector('#customers-map-canvas');
    if (!canvas) return;

    var lat = parseFloat(root.dataset.lat || '-34');
    var lng = parseFloat(root.dataset.lng || '-64');
    var zoom = parseInt(root.dataset.zoom || '4', 10);

    mapInstance = new google.maps.Map(canvas, {
      center: { lat: lat, lng: lng },
      zoom: zoom
    });

    mapInitialized = true;
    renderMarkers(root, { fitBounds: true });
    scheduleGeocodeDrain(root);
    if (pendingFocusItem) {
      focusItemOnMap(root, pendingFocusItem);
      pendingFocusItem = null;
    }
  }

  function loadGoogleMapsScript(root) {
    var apiKey = root.dataset.googleMapsApiKey || '';
    if (!apiKey || mapsScriptRequested) return;
    mapsScriptRequested = true;

    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&callback=initMap';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  function initFeaturedMapLinks() {
    var root = document.getElementById('customers-directory-root');
    if (!root) return;

    document.querySelectorAll('.customers-featured__card[data-customer-handle]').forEach(function (card) {
      function activate(e) {
        if (e && e.target && e.target.closest && e.target.closest('a.customers-featured__site-link')) return;
        var handle = card.getAttribute('data-customer-handle');
        var item = findItemByCustomerHandle(root, handle);
        if (!item) return;
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        var mapSection = document.getElementById('customers-map');
        if (mapSection) mapSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(function () {
          focusItemOnMap(root, item);
        }, 200);
      }

      card.addEventListener('click', activate);
      card.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (e.target.closest && e.target.closest('a.customers-featured__site-link')) return;
        e.preventDefault();
        activate(e);
      });
    });
  }

  function initDirectory(root) {
    if (!root) return;

    var searchInput = root.querySelector('#customers-search');
    var provinceFilter = root.querySelector('#customers-province-filter');

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        filterItems(root);
      });
    }

    if (provinceFilter) {
      provinceFilter.addEventListener('change', function () {
        filterItems(root);
      });
    }

    getCustomerItems(root).forEach(function (item) {
      item.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a')) return;
        focusItemOnMap(root, item);
      });
    });

    var mapCanvas = root.querySelector('#customers-map-canvas');
    if (mapCanvas) {
      mapCanvas.addEventListener('click', function (e) {
        if (e.target !== mapCanvas) return;
        clearMapSelection(root);
      });
    }

    window.initMap = function () {
      initGoogleMap(root);
    };

    var loadMoreBtn = root.querySelector('#customers-directory-load-more');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var pageSize = getMobilePageSize(root);
        var current = parseInt(root.dataset.mobileVisibleLimit || String(pageSize), 10);
        root.dataset.mobileVisibleLimit = String(current + pageSize);
        applyMobileListPagination(root, false);
        updateCount(
          root,
          getVisibleCustomerItems(root).length,
          getCustomerItems(root).length
        );
      });
    }

    var mobileMedia = window.matchMedia('(max-width: 989px)');
    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener('change', function () {
        applyMobileListPagination(root, true);
        updateCount(
          root,
          getVisibleCustomerItems(root).length,
          getCustomerItems(root).length
        );
      });
    }

    populateProvinceOptions(root);
    filterItems(root);
    loadGoogleMapsScript(root);
    if (window.google && window.google.maps) {
      initGoogleMap(root);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('customers-directory-root');
    initDirectory(root);
    initFeaturedMapLinks();
  });
})();
